/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppInitAppBootstrapQueryResponse, WebAppInitAppBootstrap401, WebAppInitAppBootstrap403 } from "../models/WebAppInitAppBootstrap";

export function getWebAppInitAppBootstrapUrl() {
  const res = { method: 'GET', url: `/web-app/v1/app-init` as const }
  return res
}

/**
 * @summary Get app init payload (user, client, stations, stations-groups)
 * {@link /web-app/v1/app-init}
 */
export async function webAppInitAppBootstrap(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<WebAppInitAppBootstrapQueryResponse, ResponseErrorConfig<WebAppInitAppBootstrap401 | WebAppInitAppBootstrap403>, unknown>({ method : "GET", url : getWebAppInitAppBootstrapUrl().url.toString(), ... requestConfig })
  return res.data
}